<template>
  <div class="about">

   
    <h1 class='pa-3'>Manage Payout</h1>
    <v-data-table
      v-model='selected'
        show-select
      :headers="headers"
      :items="payments"
      :search="search"
    >
    
    <template v-slot:item.payout="{item }" >
       ${{item.payout}}
    
    </template>
  
    </v-data-table>
  </div>
</template>


<script>
const fb = require("../../firebaseconfig");
export default {
  methods : {
  },
    data(){
      return{
        npo : null,
        disabled : false,
        token : null,
        notes : "",
        valid : true,
        selectedPayout : {
          donations : [],
          id : null,
          lastUpdate : null,
          methods : null,
          payout : 0,
          refurbisher : null,
          status : null,
          note : null
        },
        dialog : false,
        payments : [],
         selected : [],
            headers : [
               { text: 'Status',value: 'status'},
               { text: 'Payout ID',value: 'id'},
              { text: 'Donations',value: 'donations'},
              { text: 'Last Update',value: 'lastUpdate', filterable: true,},
              { text: 'NPO',value: 'npoName'},
              { text: 'Total Value',value: 'payout'},
              { text: 'Notes',value: 'note'},
            ],
            search : null,
      }
    },
   
     async mounted() {
        if (!this.globalRefurbisher) {
            let idTokenResult = await fb.auth.currentUser.getIdTokenResult(true)
            this.token = idTokenResult.token;
            this.globalRefurbisher = idTokenResult.claims.id;
            this.npo = idTokenResult.claims.npo;
        }
        await fb.db.collection("payment").where("refurbisher","==",this.globalRefurbisher).where("npo","==",this.npo).onSnapshot((data) => {
            this.payments = data.docs.map(item => item.data())
        });
      
    }
}
</script>